import { Reducer } from "redux";
import { Action, ActionType } from "../../../actions";
import { SSRFiltersData } from "../../../state/BookingCreateManagerV2/SSR/FiltersData";

const updateSSRFiltersData: Reducer<SSRFiltersData> = (
  state: SSRFiltersData = new SSRFiltersData(),
  action: Action<ActionType, SSRFiltersData>
) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_V2_SSR_FILTERS_UPDATED:
      return { ...state, ...action.data };
    case ActionType.BOOKING_CREATE_MANAGER_V2_SSR_FILTERS_RESET:
      return new SSRFiltersData();
    default:
      return state;
  }
};

export default updateSSRFiltersData;
